export const persistStorage = {
  getIsSession: () => localStorage.session === 'true',
  setIsSession: (isSession: boolean) => localStorage.setItem('session', JSON.stringify(isSession)),
  getAppVersion: () => localStorage.appVersion as string,
  setAppVersion: (version: string) => localStorage.setItem('appVersion', version),
}
